const CurrentYear = () => {
  const year = new Date();

  return(<span>© {year.getFullYear()}</span>)
}

export default CurrentYear
